import React from 'react'
import {TwCheckbox, TwFootnote, TwLabel, TwWrapper} from './containers'
import {CheckboxBaseProps} from './types'

export const CheckboxBase = React.forwardRef(
  (
    {
      value,
      label,
      footnote,
      renderFullFootnote,
      disabled,
      error,
      className,
      labelClassName,
      checkboxClassName,
      onClick,
      dataTestId,
      color,
      rounded,
      size = 'medium'
    }: CheckboxBaseProps,
    checkboxRef: React.Ref<HTMLInputElement>
  ) => {
    return (
      <TwWrapper
        className={className}
        $disabled={disabled}
        $withLabel={!!label}
        $withFootnote={!!footnote}
        onClick={disabled ? undefined : onClick}
        data-test-id={dataTestId}
      >
        <TwCheckbox
          ref={checkboxRef}
          tabIndex={0}
          role="checkbox"
          aria-checked={value}
          $value={value}
          $disabled={disabled}
          $error={error}
          $color={color}
          $rounded={rounded}
          $size={size}
          className={checkboxClassName}
        />
        {label && (
          <TwLabel $disabled={disabled} className={labelClassName}>
            {label}
          </TwLabel>
        )}
        {footnote && (
          <TwFootnote $full={renderFullFootnote} $disabled={disabled}>
            {footnote}
          </TwFootnote>
        )}
      </TwWrapper>
    )
  }
)
